import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Card, Form, Input, message, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import { useNavigate, useParams } from "react-router";
import { useEffect } from "react";
import CardFooterAction from "../../../components/CardFooterAction";
import { businessAreaService } from "../../../services/business-area.service";
import { officeService } from "../../../services/office.service";
import { districts } from "../../../utils/options.data";

export default function ServiceOfficeForm(){

  const { id } = useParams()

  const [form] = useForm()
  const navigate = useNavigate()

  const queryClient = useQueryClient();

  const { data: businessAreaData, isPending } = useQuery({
      queryKey: ['businessAreaData'],
      queryFn: () => businessAreaService.fetchAll(),
    })

  const { data: serviceOffice  } = useQuery({
    queryKey: ['detailFaq', id],
    queryFn: () => officeService.getById(id),
    enabled: !!id
  })

  useEffect(() => {
    if(id){
      form.setFieldsValue(serviceOffice?.data)
    }

  }, [serviceOffice, form, id])

  const storeMutation = useMutation({
    mutationFn: (data) => officeService.store(data),
    onSuccess: () => {
      queryClient.invalidateQueries('users');
      message.success('Data berhasil disimpan');
      form.resetFields();
      navigate('/customer-care/office')
    },
    onError: (error) => {
      console.log(error)
      message.error('Terjadi Kesalahan');
    }
  })

  const updateMutation = useMutation({
    mutationFn: (data) => officeService.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries('users');
      message.success('Data berhasil diubah');
      form.resetFields();
      navigate('/customer-care/office')
    },
    onError: (error) => {
      console.log(error)
      message.error('Terjadi Kesalahan');
    }
  })

  const handleSubmit = (val) => {
    const ab = businessAreaData?.responseData?.find(e => e.OBJECTID == val.abId)
    delete ab.XY_Point
    if(!id) storeMutation.mutate({...val, ab})
    else updateMutation.mutate({...val, ab})
  }

  return (
    <>
      <Card
        title={ (id ? "Ubah" : "Tambah") + " Data"}
        actions={[
          <CardFooterAction
            key={'1'}
            route={'/customer-care/office'}
            onClick={() => form.submit()}
          />
        ]}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
        >
          <Form.Item hidden name={'id'} >
            <Input/>
          </Form.Item>
          <Form.Item
            name={'regional'}
            label="Regional"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Select
              options={['Pusat', 'Timur', 'Barat & Selatan', 'Utara'].map(e => ({ value: e, label: e }))}
            />
          </Form.Item>
          <Form.Item
            name={'abId'}
            label="Area Bisnis"
            initialValue={null}
            rules={[
              {
                required: true
              }
            ]}
          >
            <Select
              loading={isPending}
              options={!isPending ? businessAreaData?.responseData?.map(e => ({
                label: e.NAMA_AB,
                value: e.OBJECTID
              })) : []}
            />
          </Form.Item>
          <Form.Item
            name={'urbanVillage'}
            label="Kelurahan"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Select
              options={districts}
              mode="tags"
              filterOption
              placeholder="Pilih atau ketik kelurahan"
            />
          </Form.Item>
          <Form.Item
            name={'street'}
            label="Jalan"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input/>
          </Form.Item>
        </Form>
      </Card>
    </>
  )
}